/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelLocation = new Class({
  Extends: QuriobotElement,
  DEFAULT_TYPE: 'city',
  template: function () {
    var base =
      '<div class="input--wrapper input--autocomplete isLoading" data-qre-id="{{ id }}" data-qre-key="{{ key }}" id="{{ eid }}">' +
      '    <div class="input--error">' +
      '        <div class="error--avatar"></div>' +
      '        <div class="error--content" aria-hidden="true">' +
      '            {{ notFoundError }}' +
      '        </div>' +
      '    </div>' +
      '    <div class="panel--autocomplete no--options" id="options__{{ eid }}">' +
      '        <div class="panel--main">' +
      '            <ul role="listbox" id="page__{{ eid }}">' +
      '            </ul>' +
      '        </div>' +
      '    </div>' +
      '    <div class="input--inner">' +
      '        <div aria-label={{ title }} role="combobox" aria-expanded="false" aria-owns="page__{{ eid }}" class="input--content">' +
      '            <input autocomplete="off" aria-autocomplete="list" aria-controls="page__{{ eid }}" type="text" placeholder="{{ placeholder }}" class="data--wrapper" id="autoCompleteInput" />' +
      '        </div>' +
      '        <button type="button" type="submit" class="input--button hidden"></button>' +
      '    </div>' +
      '</div>'

    var option =
      '<li role="option" autocomplete-id="{{ place_id }}" class="option google--location">' +
      '      <span class="autocomplete--text">{{ description }}</span>' +
      '</li>'

    return {
      base: base,
      option: option,
    }
  },
  populate: function (notFoundError) {
    var base = this.template().base
    var data = Object.merge(this.data, { notFoundError: notFoundError || 'There are no suggestions' })

    Object.each(data, function (val, key) {
      base = base.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
    })

    return base
  },
  populateOptions: function (options, append) {
    if (!options || !options.length) {
      var optionsHTML = false
    } else {
      var optionsHTML = ''
      options.each(
        function (obj) {
          var itemHTML = this.template().option
          Object.each(obj, function (val, key) {
            itemHTML = itemHTML.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
          })
          optionsHTML += itemHTML + '\n'
        }.bind(this)
      )
      this.isEmptyError('reset')
    }

    this.addToDom(optionsHTML, append)
  },
  isUpdating: false,
  autoCompleteInput: null,
  makeApiCall: function (newSearch) {
    var locType = this.data.meta.location_type || this.DEFAULT_TYPE,
      locationCountries = this.data.meta.location_countries,
      locationCities = this.data.meta.location_cities,
      value = this.autoCompleteInput.get('value'),
      type = locType

    // fetch search params.
    if (this.isUpdating) {
      return
    } else {
      this.isUpdating = true
    }

    if (!value || ((locType === 'country' || locType === 'state') && value.length < 2)) {
      this.isUpdating = false
      this.isEmptyError('reset')
      this.hide_autoCompleteOptions()
      return
    }

    // workaround
    if (locType === 'city') {
      type = '(cities)'
    }

    if (locType === 'region' || locType === 'country' || locType === 'state') {
      type = '(regions)'
    }

    var autoCompleteQuery = new google.maps.places.AutocompleteService()
    var handleGoogleAutoComplete = function (resultsData) {
      var results = []

      this.isUpdating = false

      // Check if location type is equal country
      // show results that match to country
      if (locType === 'country' && resultsData) {
        results = resultsData.filter(function (result) {
          var isElement = result.types.indexOf(locType) !== -1

          if (isElement && result.terms.length === 1) {
            return result
          }
        })
      } else if (locType === 'state' && resultsData) {
        results = resultsData.filter(function (result) {
          var isElement =
            result.types.indexOf('administrative_area_level_1') !== -1 && result.types.indexOf('political') !== -1
          if (locationCountries && locationCountries.length === 1) {
            result.description = result.structured_formatting.main_text
          }
          if (isElement && result.terms.length === 2) {
            return result
          }
        })
      } else {
        results = resultsData
        if (results && locationCountries && locationCountries.length === 1) {
          results = results.filter(function (result) {
            result.description = result.terms
              .map(function (item) {
                return item.value
              })
              .slice(0, result.terms.length - 1)
              .join(', ')
            return result
          })
        }
        if (results && locationCities && locationCities.length) {
          results = results.filter(function (result) {
            if (result.terms.length > 2) {
              var city = result.terms[result.terms.length - 3]
              if (city) {
                if (
                  locationCities.find(function (item) {
                    return item == city.value
                  })
                ) {
                  return true
                }
              }
            }
            if (result.terms.length > 1) {
              var city = result.terms[result.terms.length - 2]
              if (city) {
                if (
                  locationCities.find(function (item) {
                    return item == city.value
                  })
                ) {
                  return true
                }
              }
            }
          })
        }
      }

      this.populateOptions(results, true)
    }
    var params = {
      input: this.autoCompleteInput.get('value'),
      language: this.data.language,
      types: type === 'geocode_establishment' ? type.split('_') : [type],
    }
    if (locationCountries && locationCountries.length) {
      params.componentRestrictions = {
        country: locationCountries.map(function (item) {
          return item.toLowerCase()
        }),
      }
    }
    autoCompleteQuery.getPlacePredictions(params, handleGoogleAutoComplete.bind(this))
  },
  isEmptyError: function (reset) {
    if (reset) {
      this.element.removeClass('hasError')
      this.element.getElements('.error--content')[0].set('aria-hidden', true)
      return
    }
    this.element.addClass('hasError')
    this.element.getElements('.error--content')[0].set('aria-hidden', false)
  },
  emptyOptions: function () {
    this.page_options.set('html', '')
  },
  addToDom: function (resultsData, update) {
    this.isUpdating = false
    var _a = this.questionApi
    this.quriobot.getError(
      this.data,
      'not_found',
      null,
      function (notFoundError) {
        if (!update) {
          var htmlContent = this.populate(notFoundError)
          this.inputContainer.set('html', htmlContent)
          this.page_options = $('page__' + this.data.eid)
          this.auto_options = $('options__' + this.data.eid)
        } else {
          if (resultsData) {
            //after redo these items can be lost somehow.
            if (this.page_options == undefined) {
              if ($('page__' + this.data.eid)) {
                this.page_options = $('page__' + this.data.eid)
              } else {
                return
              }
            }

            if (this.auto_options == undefined) {
              if ($('options__' + this.data.eid)) {
                this.auto_options = $('options__' + this.data.eid)
              } else {
                return
              }
            }
            this.page_options.set('html', resultsData)
            this.show_autoCompleteOptions()
            this.attach_options()
          } else {
            this.hide_autoCompleteOptions()
            this.isEmptyError()
          }
          return
        }

        this.in()
      }.bind(this)
    )
  },
  show_autoCompleteOptions: function () {
    this.auto_options.removeClass('no--options')
    $$('.input--content').set('aria-expanded', true)
  },
  hide_autoCompleteOptions: function () {
    this.auto_options.addClass('no--options')
    $$('.input--content').set('aria-expanded', false)
  },
  attach: function () {
    var autocomplete = FunctionUtilities.debounce(this.makeApiCall.bind(this), 500)
    this.autoCompleteInput = $('autoCompleteInput')
    this.autoCompleteInput.addEvents({
      keyup: autocomplete,
    })

    if (!BrowserData.isMobile && !this.data.accessibilityMode) {
      this.autoCompleteInput.focus()
    }

    this.element.getElements('.input--button')[0].addEvents({
      click: autocomplete,
    })
  },
  attach_options: function () {
    if (this.page_options) {
      var options = this.page_options.getElements('.option')
    }
    options.each(
      function (obj, i) {
        obj.removeEvents()
        obj.addEvents({
          click: function (e) {
            e.preventDefault()
            this.selectedOption = obj.clone()
            this.after()
          }.bind(this),
        })
      }.bind(this)
    )
  },
  after: function () {
    var textVal = this.selectedOption.getElements('.autocomplete--text')[0].get('text')
    var idVal = this.selectedOption.get('autocomplete-id')
    var coder = new google.maps.Geocoder()

    coder.geocode(
      { address: textVal },
      function (results) {
        if (this.data.meta.location_type === 'geocode' && results && results.length) {
          textVal = results[0].formatted_address
        }
        this.autoCompleteInput.set('value', textVal)
        this.hide_autoCompleteOptions()
        if (this.data.meta.max_length && textVal) {
          textVal = textVal.slice(0, this.data.meta.max_length)
        }

        var answerData = {
          answer: {
            value: idVal,
            content: textVal,
            render: 'default',
          },
          id: this.element.get('data-qre-id'),
          key: this.element.get('data-qre-key'),
        }

        setTimeout(
          function () {
            this.out()
            this.answerCallback(this.data, answerData)
          }.bind(this),
          300
        )
      }.bind(this)
    )
  }
})
